import { Spin } from "antd-v5";
import User from "components/User";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import AssessmentAPI from "restAPI/AssessmentAPI";
import { AssessmentListingContent } from "types/assessment";
import { CellRenderers } from "utils/tableUtils";

import ACLink from "ac-components/ACLink/ACLink";

import { FindingDetailsGrid } from "../FindingDetailsGrid";

interface FindingPentestDetailsProps {
  finding: undefined;
}

type ExtendedAssessmentData = AssessmentListingContent & {
  assessors?: number[];
};

export default function FindingPentestDetails({
  finding,
}: FindingPentestDetailsProps) {
  const [assessmentData, setAssessmentData] =
    useState<ExtendedAssessmentData | null>(null);

  useEffect(() => {
    const assessmentId = _.get(finding, "assessments[0].id");

    if (!assessmentId) return;

    const { promise, cancel } = AssessmentAPI.getAll({
      filters: { id: [assessmentId] },
    });

    promise
      .then((response) => {
        if (response.content?.length > 0) {
          setAssessmentData(response.content[0] as ExtendedAssessmentData);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return cancel;
  }, [finding]);

  if (!assessmentData) {
    return <Spin spinning={true} />;
  }

  const assessmentFields = [
    {
      label: "Name",
      name: "name",
      path: "name",
      span: 24,
      formatter: () => (
        <ACLink
          overlay
          primary={false}
          href={`/#/assessments/${assessmentData.id}`}
          target="_blank"
          title={assessmentData.name}
        >
          {assessmentData.name}
        </ACLink>
      ),
    },
    {
      label: "Type",
      name: "type",
      path: "type",
      span: 24,
      formatter: () => assessmentData.type,
    },
    {
      label: "Start Date",
      name: "startDate",
      path: "startDate",
      span: 24,
      formatter: CellRenderers.DATE,
    },
    {
      label: "End Date",
      name: "endDate",
      path: "endDate",
      span: 24,
      formatter: CellRenderers.DATE,
    },
    {
      label: "Requestor",
      name: "requestedBy",
      path: "requestedBy",
      span: 24,
      formatter: () => (
        // @ts-expect-error - Type 'number' is not assignable to type 'string'
        <User id={assessmentData.requestedBy} />
      ),
    },
    {
      label: "Assessor(s)",
      name: "assessors",
      path: "assessors",
      span: 24,
      formatter: () =>
        (assessmentData.assessors || []).map((assessorId, i, arr) => (
          <div key={assessorId} className="d-flex align-items-center">
            {/* @ts-expect-error - Type 'number' is not assignable to type 'string' */}
            <User id={assessorId} />
            {i < arr.length - 1 && ","}
          </div>
        )),
    },
  ];

  return (
    <FindingDetailsGrid
      list={assessmentFields}
      data={assessmentData}
      labelWidth={120}
      // @ts-expect-error -- need to define type
      valueBold={false}
    />
  );
}
